export const MONTH_NAME = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
]

export const TRASHED = 0
export const ROUTE = {
  LOGIN: {
    LINK: '/login'
  },
  RESET_PASSWORD: {
    LINK: '/reset_password'
  },
  SET_PASSWORD: {
    LINK: '/set_password'
  },
  THANKYOU: {
    LINK: '/thankyou'
  },
  BOOKING: {
    LINK: '/booking',
    ACTION: {
      CATERING_READ: 'read_booking_catering',
      EQUIPMENT_READ: 'read_booking_equipment',
      ISSUE_CREATE: 'create_company_issue'
    }
  },
  CALENDAR: {
    LINK: '/calendar',
    CODE: 'read_booking_view_calendar',
    ACTION: {
      CREATE: 'create_booking_view_calendar',
      UPDATE: 'update_booking_view_calendar',
      DELETE: 'delete_booking_view_calendar'
    }
  },
  MEETING_ROOM: {
    LIST: '/meetingroom/list',
    DETAIL: '/meetingroom/detail',
    CODE: 'read_booking_view_meeting_room',
    ACTION: {
      CREATE: 'create_booking_view_meeting_room',
      UPDATE: 'update_booking_view_meeting_room',
      DELETE: 'delete_booking_view_meeting_room'
    }
  },
  FLOORPLAN: {
    LINK: '/floorplan',
    CALENDAR: '/floorplan/calendar',
    CODE: 'read_booking_view_floor_plan',
    ACTION: {
      CREATE: 'create_booking_view_floor_plan',
      UPDATE: 'update_booking_view_floor_plan',
      DELETE: 'delete_booking_view_floor_plan'
    }
  },
  USER_SETTING: {
    LINK: '/user_setting',
    CODE: 'read_localization_setting',
    ACTION: {
      UPDATE: 'update_localization_setting'
    }
  },
  ROUTE_MS_LOGIN_LANDING_PAGE: {
    LINK: '/msLoginLanding.html'
  }
}

export const monthInYear = {
  EN: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ],
  TH: [
    'มกราคม',
    'กุมภาพันธ์',
    'มีนาคม',
    'เมษายน',
    'พฤษภาคม',
    'มิถุนายน',
    'กรกฎาคม',
    'สิงหาคม',
    'กันยายน',
    'ตุลาคม',
    'พฤศจิกายน',
    'ธันวาคม'

  ]
}

export const HOLIDAY_HEADER = {
  TH: 'วันหยุด',
  EN: 'Holiday'
}

export const TEXT_ENCRYPT = {
  ACCOUNT: 'username',
  PASS: 'password',
  ACCESS_TOKEN: 'sectionId',
  IS_REGISTER_FIREBASE: 'isRegisterFirebaseBooking',
  IS_LOGIN: 'isLoginBooking',
}

export const LIST_LANGUAGE = ['EN', 'TH']

export const PARAM_SEARCH = {
  COMPANY: {
    trashed: TRASHED,
    limit: 10,
    companyName: '',
    page: 1,
    ordering: '', // sort,
    status: ''
  },
  BUILDING: {
    trashed: TRASHED,
    limit: 10,
    page: 1,
    buildingName: '',
    companyId: '',
    ordering: '', // sort,
    status: ''
  },
  FLOOR: {
    companyId: '',
    buildingId: '',
    trashed: TRASHED,
    limit: 10,
    page: 1,
    floorLevel: '',
    ordering: '',
    status: ''
  },
  ROOM: {
    companyId: '',
    buildingId: '',
    trashed: TRASHED,
    limit: 10,
    page: 1,
    floorLevel: '',
    roomName: '',
    ordering: '',
    status: '[0]'
  }
}

export const CREATE_DEFAULT = {
  CREATE: {
    TH: 'สร้าง',
    EN: 'Create',
  },
  EDIT: {
    TH: 'แก้ไข',
    EN: 'Edit ',
  },
  INFORMATION: {
    TH: 'ข้อมูล',
    EN: 'Information',
  },
  DESCRIPTION: {
    TH: 'กรุณาใส่รายละเอียดที่อยู่',
    EN: 'Please insert your address details.',
  },
  STATUS: {
    TH: 'สถานะ',
    EN: 'Status',
  },
  ADDRESS: {
    TH: 'ที่อยู่',
    EN: 'Detailed Address',
  },
  DETAIL_ADDRESS: {
    TH: 'ซอย, บ้านเลขที่, อาคาร, ถนน',
    EN: 'Unit number, house number, building, streetname',
  },
  CHARACTER: {
    TH: (amount, max) => { return `${amount} ตัวอักษร จากจำนวนสูงสุด ${max} ตัวอักษร.` },
    EN: (amount, max) => { return `${amount} of max ${max} character.` },
  },
  BACK: {
    TH: 'กลับ',
    EN: 'Back',
  },
  CLEAR: {
    TH: 'ล้างค่า',
    EN: 'Clear',
  },
  CONFIRM: {
    TH: 'ยืนยัน',
    EN: 'Confirm',
  },
  TEXT_ERROR_1: {
    TH: 'ข้อมูลของคุณมีปัญหา',
    EN: 'Your Information has a problem',
  },
  TEXT_ERROR_2: {
    TH: 'กรุณากลับไปตรวจสอบอีกครั้ง',
    EN: 'Please turn back to check.',
  },
  SELECT_COMPANY: {
    TH: 'ค้นหา และ เลือกบริษัท',
    EN: 'search and select company',
  },
  SELECT_BUILDING: {
    TH: 'ค้นหา และ เลือกตึก',
    EN: 'search and select building',
  },
  SELECT_FLOOR: {
    TH: 'ค้นหา และ เลือกเลขชั้น',
    EN: 'search and select floor No.',
  },
  SELECT_ROOM: {
    TH: 'ค้นหา และ เลือกชื่อห้อง',
    EN: 'search and select your room.',
  },
  NUMBER: {
    TH: '(ตัวเลขเท่านั้น)',
    EN: '(Only number)',
  },
  UPLOAD: {
    TH: 'อัพโหลดรูปภาพ',
    EN: 'Upload photo',
  },
  TEXT_UPLOAD: {
    TH: 'JPG หรือ PNG เท่านั้น. ขนาดแนะนำ 1200 x 628 pixels.',
    EN: 'JPG or PNG are allowed. Need to be at least 1200 x 628 pixels.',
  },
  CHOOSE_FILE: {
    TH: 'เลือกรูปภาพ',
    EN: 'Choose file',
  },
  CHOOSE_NEW_FILE: {
    TH: 'เลือกรูปภาพใหม่',
    EN: 'Choose new file',
  },
  LIMIT_FILE: {
    TH: 'กรุณาอัพโหลดไฟล์ ไม่เกิน 3 MB',
    EN: 'Please upload file least then 3 MB',
  },
  SAVE: {
    TH: 'บันทึก',
    EN: 'Save',
  },
  DONE: {
    TH: 'เสร็จ',
    EN: 'Done',
  },
  ALL: {
    TH: 'ทั้งหมด',
    EN: 'All',
  },
  GOOGLE_LOGIN_FAILURE: {
    TH: 'เกิดข้อผิดพลาดในการ sign in, กรุณาลองอีกครั้ง',
    EN: 'Error occur during sign in process. Please try again.',
  },
  GOOGLE_ERROR: {
    TH: 'กรุณาทำการล็อกอินและตรวจสอบกล่องข้อความของท่านหลังทำการเซพ',
    EN: 'Please link your google account and check your email box after saving.',
  },
  FACILITIES: {
    TH: 'สิ้งอำนวยความสะดวก',
    EN: 'Facilities',
  },
  DESCRIPTION_FACILITIES: {
    TH: 'โปรดใส่สิ่งอำนวยความสะดวก',
    EN: 'Please insert your facilities.',
  },
  ADD_FACILITIES: {
    TH: 'เพิ่มสิ่งอำนวยความสะดวก',
    EN: 'Add facilities.',
  },
  CHOOSE_FACILITIES: {
    TH: 'สิ่งอำนวยความสะดวกที่เลือก',
    EN: 'Choose Facilities',
  },
  TEXT_ERROR_PROJECT_NAME: {
    TH: 'กรุณาระบุหัวข้อการประชุม',
    EN: 'Please type meeting subject',
  },
  TEXT_ERROR_MEETING_ROOM_NAME: {
    TH: 'กรุณาเลือกห้องประชุมที่ต้องการจองก่อน',
    EN: 'Please select meeting room first.',
  },
  LIMIT_FILE3MB: {
    TH: 'มีปัญหา กรุณาอัพโหลดไฟล์ ไม่เกิน 3 MB',
    EN: 'is fail, Please upload file least then 3 MB',
  }
}

export const FILTER = {
  COMPANY: {
    TH: 'บริษัท',
    EN: 'company'
  },
  BUILDING: {
    TH: 'ตึก',
    EN: 'building'
  },
  FLOOR: {
    TH: 'เลขชั้น',
    EN: 'floor No.'
  },
  ROOM: {
    TH: 'ห้อง',
    EN: 'room'
  },
  MEETING_ROOM: {
    TH: 'ห้องประชุม',
    EN: 'meeting room'
  },
  PROJECT_NAME: {
    TH: 'ชื่อโครงการ',
    EN: 'project name'
  },
  OWNER: {
    TH: 'เจ้าของ',
    EN: 'owner'
  },
  START_TIME: {
    TH: 'เวลาเริ่มต้น',
    EN: 'start time'
  },
  END_TIME: {
    TH: 'เวลาสิ้นสุด',
    EN: 'end time'
  },
  DATE: {
    TH: 'วันที่',
    EN: 'date'
  },
  USER: {
    TH: 'ชื่อผู้ใช้',
    EN: 'username'
  },
  HOLIDAY: {
    TH: 'วันหยุด',
    EN: 'holiday'
  },
  LIST_STATUS: [
    {
      name: {
        TH: 'ทุกสถานะ',
        EN: 'all status'
      },
      id: ''
    },
    {
      name: {
        TH: 'เปิดใช้งาน',
        EN: 'Active'
      },
      id: 0
    },
    {
      name: {
        TH: 'ระงับการใช้งานชั่วคราว',
        EN: 'Inactive'
      },
      id: 1
    },
    {
      name: {
        TH: 'ปิดการใช้งาน ',
        EN: 'Close'
      },
      id: 2
    }
  ],
  BOOKING_STATUS: [
    {
      name: {
        TH: 'ทุกสถานะ',
        EN: 'all status'
      },
      id: ''
    },
    {
      name: {
        TH: 'รอ',
        EN: 'waiting'
      },
      id: 2
    },
    {
      name: {
        TH: 'ใช้งาน',
        EN: 'in use'
      },
      id: 1
    }
    // {
    //   name: {
    //     TH: 'เสร็จสิ้น',
    //     EN: 'completed'
    //   },
    //   id: 0
    // },

  ],
  CATERING_STATUS: [
    {
      name: {
        TH: 'ทุกสถานะ',
        EN: 'all status'
      },
      id: ''
    },
    {
      name: {
        TH: 'เสร็จสิ้น',
        EN: 'Completed'
      },
      id: 0
    },
    {
      name: {
        TH: 'รอ',
        EN: 'Waiting'
      },
      id: 1
    }
  ],
  EQUIPMENT: {
    TH: 'อุปกรณ์',
    EN: 'equipment'
  },
  EQUIPMENT_TYPE: [
    {
      name: {
        TH: 'ทุกชนิด',
        EN: 'all type'
      },
      id: ''
    },
    {
      name: {
        TH: 'เครื่องดื่ม',
        EN: 'Drink'
      },
      id: 0
    },
    {
      name: {
        TH: 'อาหาร',
        EN: 'Food'
      },
      id: 1
    },
    {
      name: {
        TH: 'อุปกรณ์',
        EN: 'Equipment'
      },
      id: 2
    },
    {
      name: {
        TH: 'สิ่งอำนวยความสะดวก',
        EN: 'Facility'
      },
      id: 3
    }
  ],
  EQUIPMENT_STATUS: [
    {
      name: {
        TH: 'ทุกสถานะ',
        EN: 'all status'
      },
      id: ''
    },
    {
      name: {
        TH: 'เปิดใช้งาน',
        EN: 'Active'
      },
      id: 0
    },
    {
      name: {
        TH: 'งดใช้งานชั่วคราว',
        EN: 'Inactive'
      },
      id: 1
    },
    {
      name: {
        TH: 'ยกเลิกใช้งาน',
        EN: 'Closed'
      },
      id: 2
    }
  ],
  LIST_LANGUAGE: [
    {
      name: {
        TH: 'ไทย',
        EN: 'English'
      },
      id: 0
    }
  ],
  ISSUE_STATUS: [
    {
      name: {
        TH: 'ทุกสถานะ',
        EN: 'all status'
      },
      id: ''
    },
    {
      name: {
        TH: 'ดำเนินการแก้ไขแล้ว',
        EN: 'Active'
      },
      id: 0
    },
    {
      name: {
        TH: 'กำลังดำเนินการ',
        EN: 'Closed'
      },
      id: 1
    },
    {
      name: {
        TH: 'รอดำเนินการ',
        EN: 'Pending'
      },
      id: 2
    }
  ]
}

export const COMPANY_TOKEN_TYPE = {
  GOOGLE: 'google',
  MICROSOFT: 'microsoft',
}
